import React from "react";
import { Nav } from "react-bootstrap";

/**
 * Shared sub-tab (level a/b) navigation + empty-state placeholder
 * used by every main tab in Communication Management.
 */
export const CommSubTabs = ({ tabs, activeKey, onSelect }) => (
  <Nav
    variant="tabs"
    activeKey={activeKey}
    onSelect={onSelect}
    className="comm-subtabs"
  >
    {tabs.map((t) => (
      <Nav.Item key={t.key}>
        <Nav.Link eventKey={t.key}>
          {t.icon ? <i className={`${t.icon} me-2`} /> : null}
          {t.label}
        </Nav.Link>
      </Nav.Item>
    ))}
  </Nav>
);

export const CommEmptyState = ({ icon, title, description }) => (
  <div className="comm-empty">
    <i className={icon} />
    <h6>{title}</h6>
    <p>{description}</p>
  </div>
);
